module.exports = "/contribution/resources/c978e5a1acf6a502679c92200e78ef61.pdf";